/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2018 Deere & Company

import './index.scss';
import AmountOfUseModalBody from './amount-of-use-modal-body';
import MeasurementReading from '../../state/measurement-reading';
import ModalHeader from '../modal-header';
import PropTypes from 'prop-types';
import React from 'react';
import WarrantyMediumModal from '../modal';

const AmountOfUseModal = (props) => (
    <WarrantyMediumModal
        className="amount-of-use-modal"
        isOpen={props.isModalOpen}
    >
        <ModalHeader
            modalTitle="AMOUNT_OF_USE"
            onCloseButtonClick={props.onCloseButtonClick}
        />
        <AmountOfUseModalBody
            measurementReadings={props.measurementReadings}
        />
    </WarrantyMediumModal>
);

AmountOfUseModal.displayName = 'AmountOfUseModal';
AmountOfUseModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onCloseButtonClick: PropTypes.func.isRequired,
};

export default AmountOfUseModal;
